import { DefaultLayout } from "../../layouts/Default";
import { TopNavigation } from "../../themes/Default/components/TopNavigation";
import { Main } from "../../themes/Default/components/Main";
import {DashboardWrapper} from "../../themes/Default/components/Dashboard";
import { Card } from "../../themes/Default/components/Dashboard/components";
import $ from "jquery";
import Swiper from "swiper";
import Scrollbar from "smooth-scrollbar";
import Isotope from "isotope-layout";
import "packery"; 
import ApexCharts from "apexcharts";
import PureCounter from "@srexi/purecounterjs";
import { useEffect, useState } from "react";
import { CardNumbers } from "../../themes/Default/components/Dashboard/components/Widget/CardNumbers";
import { dashboardManagement } from "../../hooks/api/DashboardManagement";
import { CardGroups } from "../../themes/Default/components/Dashboard/components/Widget/CardGroups";
import { TableHead } from "../../themes/Default/components/List/components/Body/components/TableHead";
import { TableRow } from "../../themes/Default/components/List/components/Body/components/TableHead/components/TableRow";
import { TableHeadCell } from "../../themes/Default/components/List/components/Body/components/TableHead/components/TableRow/components/TableHeadCell";
import { TableBody } from "../../themes/Default/components/List/components/Body/components/TableBody";
import { TableDataCell } from "../../themes/Default/components/List/components/Body/components/TableBody/components/TableDataCell";
import { Body as ListBody } from "../../themes/Default/components/List/components/Body";
import { useNavigate } from "react-router-dom";
import { Button } from "../../themes/Default/components/TopNavigation/components/Button";
import { List } from "../../themes/Default/components/List";
import { Header as ListHeader } from "../../themes/Default/components/List/components/Header";
import { Title as ListTitle } from "../../themes/Default/components/List/components/Header/components/Title";

const Dashboard = () => {
    const navigate = useNavigate();

    const { 
        useStudentStatusInGroupsMutation, 
        useGroupsBelowMinimumStudentsMutation, 
        useStudentAbsenceMutation 
    } = dashboardManagement;

    const [studentStatusInGroup, setStudentStatusInGroup] = useState({
        group: {},
        camp: {}
    });
    const [studentStatus] = useStudentStatusInGroupsMutation();

    const [groupsBelowMinimum, setGroupsBelowMinimum] = useState([]);
    const [groupsBelowMinimumList] = useGroupsBelowMinimumStudentsMutation();

    const [students, setStudents] = useState([]);
    const [studentsAbsence] = useStudentAbsenceMutation();

    const gotoEditGroup = (groupId) => {
        navigate("/groups/" + groupId + "/attendance");
    };

    useEffect(() => {
        const fetchData = async () => {
            const [studentGroupResult, studentCampResult, groupsResult, studentAbsenceResult] = await Promise.all([
                studentStatus({ type: 'group' }),
                studentStatus({ type: 'camp' }), 
                groupsBelowMinimumList(),
                studentsAbsence()
            ]);

            setStudentStatusInGroup({
                group: studentGroupResult?.data?.records,
                camp: studentCampResult?.data?.records
            });
            setGroupsBelowMinimum(groupsResult?.data?.records);
            setStudents(studentAbsenceResult?.data?.records);

            initializeCounters();
        };
    
        fetchData();
    }, []);
    
    const initializeCounters = () => {
        new PureCounter();
    };

    return (
        <DefaultLayout>
            <TopNavigation />
            <Main>
                <DashboardWrapper>
                    {/* <div class="item-1 grid-item grid-item--width-3 grid-item--height-6">
                        <div class="dashboard__card">
                            <div class="dashboard__card-header">
                                <div class="dashboard__card-title">Profesori</div>
                                <div class="dashboard__card-actions">
                                    <button class="btn-dash-more">
                                        <i class="fa-regular fa-ellipsis-vertical"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="dashboard__card-body">
                                <div class="dashboard__card-chart-1"></div>
                            </div>
                        </div>
                    </div>
                    <div class="item-2 grid-item grid-item--width-3 grid-item--height-3">
                        <div class="dashboard__card">
                            <div class="dashboard__card-header">
                                <div class="dashboard__card-title">Otkazani časovi</div>
                                <div class="dashboard__card-actions">
                                    <button class="btn-dash-more">
                                        <i class="fa-regular fa-ellipsis-vertical"></i>
                                    </button>
                                </div>
                                <div class="dashboard__card-info dashboard__card-info--error">
                                    <span class="num purecounter" data-purecounter-start="0" data-purecounter-end="5" data-purecounter-duration="1"></span>
                                    <span>grupa</span>
                                </div>
                            </div>
                            <div class="dashboard__card-slider">
                                <div class="swiper">
                                    <div class="swiper-wrapper">
                                        <div class="swiper-slide">
                                            <div class="dashboard__card-slider-item">
                                                <div class="dashboard__card-slider-item-img dashboard__card-slider-item-img--error">
                                                    <img src="assets/img/dash-ico-1.svg" alt="" />
                                                </div>
                                                <div class="dashboard__card-slider-item-title">CAMBRIDGE</div>
                                                <div class="dashboard__card-slider-item-name">
                                                    <span class="role">Profesor: </span>
                                                    <span class="name">Marija Gajić</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="swiper-slide">
                                            <div class="dashboard__card-slider-item">
                                                <div
                                                    class="dashboard__card-slider-item-img dashboard__card-slider-item-img--error"
                                                    style= {{background: "#17bfba"}}
                                                >
                                                    <img src="assets/img/dash-ico-2.svg" alt="" />
                                                </div>
                                                <div class="dashboard__card-slider-item-title">KIDS BOX</div>
                                                <div class="dashboard__card-slider-item-name">
                                                    <span class="role">Profesor: </span>
                                                    <span class="name">Jelena Matić</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="swiper-slide">
                                            <div class="dashboard__card-slider-item">
                                                <div class="dashboard__card-slider-item-img">
                                                    <img src="assets/img/dash-ico-3.svg" alt="" />
                                                </div>
                                                <div class="dashboard__card-slider-item-title">CAMBRIDGE</div>
                                                <div class="dashboard__card-slider-item-name">
                                                    <span class="role">Profesor: </span>
                                                    <span class="name">Marija Gajić</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="dashboard__card-slider-pagination swiper-pagination"></div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <Card
                        item={3} width={6} height={3}
                        title="Manjak polaznika"
                        info={
                            <>
                                <span className="num purecounter" data-purecounter-start="0" data-purecounter-end={groupsBelowMinimum?.length} data-purecounter-duration="1"></span>
                                <span className="txt"> grupa</span>
                            </>
                        }
                        infoType="warning"
                        actions={[
                            { label: "Izvesti", icon: "fa-regular fa-cloud-arrow-down", onClick: () => console.log("edit") },
                        ]}
                    >
                        {groupsBelowMinimum?.length > 0 && (
                            <CardGroups 
                                groups={groupsBelowMinimum} 
                                bigSlidesPerView={3}
                                smallSlidesPerView={2}
                            />
                        )}
                    </Card>
                    {/* <div class="item-4 grid-item grid-item--width-3 grid-item--height-3">
                        <div class="dashboard__card">
                            <div class="dashboard__card-body">
                                <div class="main-content__calendar">
                                    <div class="swiper">
                                        <div class="swiper-wrapper">
                                            <div class="swiper-slide">
                                                <div class="month">
                                                    <div class="month-header">January 2025</div>
                                                    <div class="weekdays">
                                                        <div>P</div>
                                                        <div>U</div>
                                                        <div>S</div>
                                                        <div>Č</div>
                                                        <div>P</div>
                                                        <div>S</div>
                                                        <div>N</div>
                                                    </div>
                                                    <div class="days">
                                                        <div></div>
                                                        <div></div>
                                                        <div class="day disabled">1</div>
                                                        <div class="day selected-solid notification-warning disabled">2</div>
                                                        <div class="day disabled">3</div>
                                                        <div class="day weekend disabled">4</div>
                                                        <div class="day weekend disabled">5</div>
                                                        <div class="day disabled">6</div>
                                                        <div class="day disabled">7</div>
                                                        <div class="day disabled">8</div>
                                                        <div class="day disabled">9</div>
                                                        <div class="day disabled">10</div>
                                                        <div class="day weekend disabled">11</div>
                                                        <div class="day weekend selected-solid notification-success disabled">12</div>
                                                        <div class="day disabled">13</div>
                                                        <div class="day selected-solid disabled">14</div>
                                                        <div class="day disabled">15</div>
                                                        <div class="day disabled">16</div>
                                                        <div class="day selected-dashed disabled">17</div>
                                                        <div class="day weekend disabled">18</div>
                                                        <div class="day weekend disabled">19</div>
                                                        <div class="day disabled">20</div>
                                                        <div class="day disabled">21</div>
                                                        <div class="day disabled">22</div>
                                                        <div class="day disabled">23</div>
                                                        <div class="day disabled">24</div>
                                                        <div class="day weekend disabled">25</div>
                                                        <div class="day weekend disabled">26</div>
                                                        <div class="day selected-dashed disabled">27</div>
                                                        <div class="day disabled">28</div>
                                                        <div class="day disabled">29</div>
                                                        <div class="day disabled">30</div>
                                                        <div class="day disabled">31</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="swiper-slide">
                                                <div class="month">
                                                    <div class="month-header">February 2025</div>
                                                    <div class="weekdays">
                                                        <div>P</div>
                                                        <div>U</div>
                                                        <div>S</div>
                                                        <div>Č</div>
                                                        <div>P</div>
                                                        <div>S</div>
                                                        <div>N</div>
                                                    </div>
                                                    <div class="days">
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div class="day weekend disabled">1</div>
                                                        <div class="day weekend selected-solid notification-warning disabled">2</div>
                                                        <div class="day disabled">3</div>
                                                        <div class="day disabled">4</div>
                                                        <div class="day disabled">5</div>
                                                        <div class="day disabled">6</div>
                                                        <div class="day disabled">7</div>
                                                        <div class="day weekend disabled">8</div>
                                                        <div class="day weekend disabled">9</div>
                                                        <div class="day disabled">10</div>
                                                        <div class="day disabled">11</div>
                                                        <div class="day selected-solid notification-success disabled">12</div>
                                                        <div class="day disabled">13</div>
                                                        <div class="day selected-solid disabled">14</div>
                                                        <div class="day weekend disabled">15</div>
                                                        <div class="day weekend disabled">16</div>
                                                        <div class="day selected-dashed disabled">17</div>
                                                        <div class="day disabled">18</div>
                                                        <div class="day disabled">19</div>
                                                        <div class="day disabled">20</div>
                                                        <div class="day disabled">21</div>
                                                        <div class="day weekend disabled">22</div>
                                                        <div class="day weekend disabled">23</div>
                                                        <div class="day current-day">24</div>
                                                        <div class="day">25</div>
                                                        <div class="day">26</div>
                                                        <div class="day selected-dashed">27</div>
                                                        <div class="day">28</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="swiper-slide">
                                                <div class="month">
                                                    <div class="month-header">March 2025</div>
                                                    <div class="weekdays">
                                                        <div>P</div>
                                                        <div>U</div>
                                                        <div>S</div>
                                                        <div>Č</div>
                                                        <div>P</div>
                                                        <div>S</div>
                                                        <div>N</div>
                                                    </div>
                                                    <div class="days">
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div class="day weekend">1</div>
                                                        <div class="day weekend selected-solid notification-warning">2</div>
                                                        <div class="day">3</div>
                                                        <div class="day">4</div>
                                                        <div class="day">5</div>
                                                        <div class="day">6</div>
                                                        <div class="day">7</div>
                                                        <div class="day weekend">8</div>
                                                        <div class="day weekend">9</div>
                                                        <div class="day">10</div>
                                                        <div class="day">11</div>
                                                        <div class="day selected-solid notification-success">12</div>
                                                        <div class="day">13</div>
                                                        <div class="day selected-solid">14</div>
                                                        <div class="day weekend">15</div>
                                                        <div class="day weekend">16</div>
                                                        <div class="day selected-dashed">17</div>
                                                        <div class="day">18</div>
                                                        <div class="day">19</div>
                                                        <div class="day">20</div>
                                                        <div class="day">21</div>
                                                        <div class="day weekend">22</div>
                                                        <div class="day weekend">23</div>
                                                        <div class="day">24</div>
                                                        <div class="day">25</div>
                                                        <div class="day">26</div>
                                                        <div class="day selected-dashed">27</div>
                                                        <div class="day">28</div>
                                                        <div class="day weekend">29</div>
                                                        <div class="day weekend">30</div>
                                                        <div class="day">31</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="swiper-slide">
                                                <div class="month">
                                                    <div class="month-header">April 2025</div>
                                                    <div class="weekdays">
                                                        <div>P</div>
                                                        <div>U</div>
                                                        <div>S</div>
                                                        <div>Č</div>
                                                        <div>P</div>
                                                        <div>S</div>
                                                        <div>N</div>
                                                    </div>
                                                    <div class="days">
                                                        <div></div>
                                                        <div class="day">1</div>
                                                        <div class="day selected-solid notification-warning">2</div>
                                                        <div class="day">3</div>
                                                        <div class="day">4</div>
                                                        <div class="day weekend">5</div>
                                                        <div class="day weekend">6</div>
                                                        <div class="day">7</div>
                                                        <div class="day">8</div>
                                                        <div class="day">9</div>
                                                        <div class="day">10</div>
                                                        <div class="day">11</div>
                                                        <div class="day weekend selected-solid notification-success">12</div>
                                                        <div class="day weekend">13</div>
                                                        <div class="day selected-solid">14</div>
                                                        <div class="day">15</div>
                                                        <div class="day">16</div>
                                                        <div class="day selected-dashed">17</div>
                                                        <div class="day">18</div>
                                                        <div class="day weekend">19</div>
                                                        <div class="day weekend">20</div>
                                                        <div class="day">21</div>
                                                        <div class="day">22</div>
                                                        <div class="day">23</div>
                                                        <div class="day">24</div>
                                                        <div class="day">25</div>
                                                        <div class="day weekend">26</div>
                                                        <div class="day weekend selected-dashed">27</div>
                                                        <div class="day">28</div>
                                                        <div class="day">29</div>
                                                        <div class="day">30</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="swiper-slide">
                                                <div class="month">
                                                    <div class="month-header">May 2025</div>
                                                    <div class="weekdays">
                                                        <div>P</div>
                                                        <div>U</div>
                                                        <div>S</div>
                                                        <div>Č</div>
                                                        <div>P</div>
                                                        <div>S</div>
                                                        <div>N</div>
                                                    </div>
                                                    <div class="days">
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div class="day">1</div>
                                                        <div class="day selected-solid notification-warning">2</div>
                                                        <div class="day weekend">3</div>
                                                        <div class="day weekend">4</div>
                                                        <div class="day">5</div>
                                                        <div class="day">6</div>
                                                        <div class="day">7</div>
                                                        <div class="day">8</div>
                                                        <div class="day">9</div>
                                                        <div class="day weekend">10</div>
                                                        <div class="day weekend">11</div>
                                                        <div class="day selected-solid notification-success">12</div>
                                                        <div class="day">13</div>
                                                        <div class="day selected-solid">14</div>
                                                        <div class="day">15</div>
                                                        <div class="day">16</div>
                                                        <div class="day weekend selected-dashed">17</div>
                                                        <div class="day weekend">18</div>
                                                        <div class="day">19</div>
                                                        <div class="day">20</div>
                                                        <div class="day">21</div>
                                                        <div class="day">22</div>
                                                        <div class="day">23</div>
                                                        <div class="day weekend">24</div>
                                                        <div class="day weekend">25</div>
                                                        <div class="day">26</div>
                                                        <div class="day selected-dashed">27</div>
                                                        <div class="day">28</div>
                                                        <div class="day">29</div>
                                                        <div class="day">30</div>
                                                        <div class="day weekend">31</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="swiper-slide">
                                                <div class="month">
                                                    <div class="month-header">June 2025</div>
                                                    <div class="weekdays">
                                                        <div>P</div>
                                                        <div>U</div>
                                                        <div>S</div>
                                                        <div>Č</div>
                                                        <div>P</div>
                                                        <div>S</div>
                                                        <div>N</div>
                                                    </div>
                                                    <div class="days">
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div class="day weekend disabled">1</div>
                                                        <div class="day">2</div>
                                                        <div class="day">3</div>
                                                        <div class="day">4</div>
                                                        <div class="day">5</div>
                                                        <div class="day">6</div>
                                                        <div class="day weekend disabled">7</div>
                                                        <div class="day weekend disabled">8</div>
                                                        <div class="day">9</div>
                                                        <div class="day">10</div>
                                                        <div class="day">11</div>
                                                        <div class="day current-day">12</div>
                                                        <div class="day">13</div>
                                                        <div class="day weekend disabled">14</div>
                                                        <div class="day weekend disabled">15</div>
                                                        <div class="day">16</div>
                                                        <div class="day">17</div>
                                                        <div class="day">18</div>
                                                        <div class="day">19</div>
                                                        <div class="day">20</div>
                                                        <div class="day weekend disabled">21</div>
                                                        <div class="day weekend disabled">22</div>
                                                        <div class="day">23</div>
                                                        <div class="day">24</div>
                                                        <div class="day">25</div>
                                                        <div class="day">26</div>
                                                        <div class="day">27</div>
                                                        <div class="day weekend disabled">28</div>
                                                        <div class="day weekend disabled">29</div>
                                                        <div class="day">30</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="swiper-slide">
                                                <div class="month">
                                                    <div class="month-header">July 2025</div>
                                                    <div class="weekdays">
                                                        <div>P</div>
                                                        <div>U</div>
                                                        <div>S</div>
                                                        <div>Č</div>
                                                        <div>P</div>
                                                        <div>S</div>
                                                        <div>N</div>
                                                    </div>
                                                    <div class="days">
                                                        <div></div>
                                                        <div class="day">1</div>
                                                        <div class="day selected-solid notification-warning">2</div>
                                                        <div class="day">3</div>
                                                        <div class="day">4</div>
                                                        <div class="day weekend">5</div>
                                                        <div class="day weekend">6</div>
                                                        <div class="day">7</div>
                                                        <div class="day">8</div>
                                                        <div class="day">9</div>
                                                        <div class="day">10</div>
                                                        <div class="day">11</div>
                                                        <div class="day weekend selected-solid notification-success">12</div>
                                                        <div class="day weekend">13</div>
                                                        <div class="day selected-solid">14</div>
                                                        <div class="day">15</div>
                                                        <div class="day">16</div>
                                                        <div class="day selected-dashed">17</div>
                                                        <div class="day">18</div>
                                                        <div class="day weekend">19</div>
                                                        <div class="day weekend">20</div>
                                                        <div class="day">21</div>
                                                        <div class="day">22</div>
                                                        <div class="day">23</div>
                                                        <div class="day">24</div>
                                                        <div class="day">25</div>
                                                        <div class="day weekend">26</div>
                                                        <div class="day weekend selected-dashed">27</div>
                                                        <div class="day">28</div>
                                                        <div class="day">29</div>
                                                        <div class="day">30</div>
                                                        <div class="day">31</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="swiper-slide">
                                                <div class="month">
                                                    <div class="month-header">August 2025</div>
                                                    <div class="weekdays">
                                                        <div>P</div>
                                                        <div>U</div>
                                                        <div>S</div>
                                                        <div>Č</div>
                                                        <div>P</div>
                                                        <div>S</div>
                                                        <div>N</div>
                                                    </div>
                                                    <div class="days">
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div class="day">1</div>
                                                        <div class="day weekend selected-solid notification-warning">2</div>
                                                        <div class="day weekend">3</div>
                                                        <div class="day">4</div>
                                                        <div class="day">5</div>
                                                        <div class="day">6</div>
                                                        <div class="day">7</div>
                                                        <div class="day">8</div>
                                                        <div class="day weekend">9</div>
                                                        <div class="day weekend">10</div>
                                                        <div class="day">11</div>
                                                        <div class="day selected-solid notification-success">12</div>
                                                        <div class="day">13</div>
                                                        <div class="day selected-solid">14</div>
                                                        <div class="day">15</div>
                                                        <div class="day weekend">16</div>
                                                        <div class="day weekend selected-dashed">17</div>
                                                        <div class="day">18</div>
                                                        <div class="day">19</div>
                                                        <div class="day">20</div>
                                                        <div class="day">21</div>
                                                        <div class="day">22</div>
                                                        <div class="day weekend">23</div>
                                                        <div class="day weekend">24</div>
                                                        <div class="day">25</div>
                                                        <div class="day">26</div>
                                                        <div class="day selected-dashed">27</div>
                                                        <div class="day">28</div>
                                                        <div class="day">29</div>
                                                        <div class="day weekend">30</div>
                                                        <div class="day weekend">31</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="swiper-slide">
                                                <div class="month">
                                                    <div class="month-header">September 2025</div>
                                                    <div class="weekdays">
                                                        <div>P</div>
                                                        <div>U</div>
                                                        <div>S</div>
                                                        <div>Č</div>
                                                        <div>P</div>
                                                        <div>S</div>
                                                        <div>N</div>
                                                    </div>
                                                    <div class="days">
                                                        <div class="day">1</div>
                                                        <div class="day selected-solid notification-warning">2</div>
                                                        <div class="day">3</div>
                                                        <div class="day">4</div>
                                                        <div class="day">5</div>
                                                        <div class="day weekend">6</div>
                                                        <div class="day weekend">7</div>
                                                        <div class="day">8</div>
                                                        <div class="day">9</div>
                                                        <div class="day">10</div>
                                                        <div class="day">11</div>
                                                        <div class="day selected-solid notification-success">12</div>
                                                        <div class="day weekend">13</div>
                                                        <div class="day weekend selected-solid">14</div>
                                                        <div class="day">15</div>
                                                        <div class="day">16</div>
                                                        <div class="day selected-dashed">17</div>
                                                        <div class="day">18</div>
                                                        <div class="day">19</div>
                                                        <div class="day weekend">20</div>
                                                        <div class="day weekend">21</div>
                                                        <div class="day">22</div>
                                                        <div class="day">23</div>
                                                        <div class="day">24</div>
                                                        <div class="day">25</div>
                                                        <div class="day">26</div>
                                                        <div class="day weekend selected-dashed">27</div>
                                                        <div class="day weekend">28</div>
                                                        <div class="day">29</div>
                                                        <div class="day">30</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="swiper-slide">
                                                <div class="month">
                                                    <div class="month-header">October 2025</div>
                                                    <div class="weekdays">
                                                        <div>P</div>
                                                        <div>U</div>
                                                        <div>S</div>
                                                        <div>Č</div>
                                                        <div>P</div>
                                                        <div>S</div>
                                                        <div>N</div>
                                                    </div>
                                                    <div class="days">
                                                        <div></div>
                                                        <div></div>
                                                        <div class="day">1</div>
                                                        <div class="day selected-solid notification-warning">2</div>
                                                        <div class="day">3</div>
                                                        <div class="day weekend">4</div>
                                                        <div class="day weekend">5</div>
                                                        <div class="day">6</div>
                                                        <div class="day">7</div>
                                                        <div class="day">8</div>
                                                        <div class="day">9</div>
                                                        <div class="day">10</div>
                                                        <div class="day weekend">11</div>
                                                        <div class="day weekend selected-solid notification-success">12</div>
                                                        <div class="day">13</div>
                                                        <div class="day selected-solid">14</div>
                                                        <div class="day">15</div>
                                                        <div class="day">16</div>
                                                        <div class="day selected-dashed">17</div>
                                                        <div class="day weekend">18</div>
                                                        <div class="day weekend">19</div>
                                                        <div class="day">20</div>
                                                        <div class="day">21</div>
                                                        <div class="day">22</div>
                                                        <div class="day">23</div>
                                                        <div class="day">24</div>
                                                        <div class="day weekend">25</div>
                                                        <div class="day weekend">26</div>
                                                        <div class="day selected-dashed">27</div>
                                                        <div class="day">28</div>
                                                        <div class="day">29</div>
                                                        <div class="day">30</div>
                                                        <div class="day">31</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="swiper-slide">
                                                <div class="month">
                                                    <div class="month-header">November 2025</div>
                                                    <div class="weekdays">
                                                        <div>P</div>
                                                        <div>U</div>
                                                        <div>S</div>
                                                        <div>Č</div>
                                                        <div>P</div>
                                                        <div>S</div>
                                                        <div>N</div>
                                                    </div>
                                                    <div class="days">
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div class="day weekend">1</div>
                                                        <div class="day weekend selected-solid notification-warning">2</div>
                                                        <div class="day">3</div>
                                                        <div class="day">4</div>
                                                        <div class="day">5</div>
                                                        <div class="day">6</div>
                                                        <div class="day">7</div>
                                                        <div class="day weekend">8</div>
                                                        <div class="day weekend">9</div>
                                                        <div class="day">10</div>
                                                        <div class="day">11</div>
                                                        <div class="day selected-solid notification-success">12</div>
                                                        <div class="day">13</div>
                                                        <div class="day selected-solid">14</div>
                                                        <div class="day weekend">15</div>
                                                        <div class="day weekend">16</div>
                                                        <div class="day selected-dashed">17</div>
                                                        <div class="day">18</div>
                                                        <div class="day">19</div>
                                                        <div class="day">20</div>
                                                        <div class="day">21</div>
                                                        <div class="day weekend">22</div>
                                                        <div class="day weekend">23</div>
                                                        <div class="day">24</div>
                                                        <div class="day">25</div>
                                                        <div class="day">26</div>
                                                        <div class="day selected-dashed">27</div>
                                                        <div class="day">28</div>
                                                        <div class="day weekend">29</div>
                                                        <div class="day weekend">30</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="swiper-slide">
                                                <div class="month">
                                                    <div class="month-header">December 2025</div>
                                                    <div class="weekdays">
                                                        <div>P</div>
                                                        <div>U</div>
                                                        <div>S</div>
                                                        <div>Č</div>
                                                        <div>P</div>
                                                        <div>S</div>
                                                        <div>N</div>
                                                    </div>
                                                    <div class="days">
                                                        <div class="day">1</div>
                                                        <div class="day selected-solid notification-warning">2</div>
                                                        <div class="day">3</div>
                                                        <div class="day">4</div>
                                                        <div class="day">5</div>
                                                        <div class="day weekend">6</div>
                                                        <div class="day weekend">7</div>
                                                        <div class="day">8</div>
                                                        <div class="day">9</div>
                                                        <div class="day">10</div>
                                                        <div class="day">11</div>
                                                        <div class="day selected-solid notification-success">12</div>
                                                        <div class="day weekend">13</div>
                                                        <div class="day weekend selected-solid">14</div>
                                                        <div class="day">15</div>
                                                        <div class="day">16</div>
                                                        <div class="day selected-dashed">17</div>
                                                        <div class="day">18</div>
                                                        <div class="day">19</div>
                                                        <div class="day weekend">20</div>
                                                        <div class="day weekend">21</div>
                                                        <div class="day">22</div>
                                                        <div class="day">23</div>
                                                        <div class="day">24</div>
                                                        <div class="day">25</div>
                                                        <div class="day">26</div>
                                                        <div class="day weekend selected-dashed">27</div>
                                                        <div class="day weekend">28</div>
                                                        <div class="day">29</div>
                                                        <div class="day">30</div>
                                                        <div class="day">31</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="dashboard__card-month-prev swiper-button-prev"></div>
                                        <div class="dashboard__card-month-next swiper-button-next"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item-5 grid-item grid-item--width-3 grid-item--height-3">
                        <div class="dashboard__card">
                            <div class="dashboard__card-header">
                                <div class="dashboard__card-title">Nedovoljan fond časova</div>
                                <div class="dashboard__card-actions">
                                    <button class="btn-dash-more">
                                        <i class="fa-regular fa-ellipsis-vertical"></i>
                                    </button>
                                </div>
                                <div class="dashboard__card-info dashboard__card-info--error">
                                    <span class="num purecounter" data-purecounter-start="0" data-purecounter-end="4" data-purecounter-duration="1"></span>
                                    <span class="txt">grupe</span>
                                </div>
                            </div>
                            <div class="dashboard__card-body">
                                <div class="dashboard__card-chart-5"></div>
                            </div>
                        </div>
                    </div> */}
                    <Card
                        item={6} width={3} height={3}
                        title="Ugovori - Godišnji kurs"
                        actions={[
                            { label: "Izvesti", icon: "fa-regular fa-cloud-arrow-down", onClick: () => console.log("edit") },
                        ]}
                    >   
                        <CardNumbers title={"Poslat"} type={"success"} number={studentStatusInGroup?.group?.sent} />
                        <CardNumbers title={"Upisan"} type={"success"} number={studentStatusInGroup?.group?.enrolled} />
                        <CardNumbers title={"Bez ugovora"} type={"warning"} number={studentStatusInGroup?.group?.reservation} students={studentStatusInGroup.group.reservationStudents}/>
                        <CardNumbers title={"Gratis"} type={"warning"} number={studentStatusInGroup?.group?.free} />
                    </Card>

                    <Card
                        item={6} width={3} height={3}
                        title="Ugovori - Jezički kamp"
                        actions={[
                            { label: "Izvesti", icon: "fa-regular fa-cloud-arrow-down", onClick: () => console.log("edit") },
                        ]}
                    >   
                        <CardNumbers title={"Poslat"} type={"success"} number={studentStatusInGroup?.camp?.sent} />
                        <CardNumbers title={"Upisan"} type={"success"} number={studentStatusInGroup?.camp?.enrolled} />
                        <CardNumbers title={"Bez ugovora"} type={"warning"} number={studentStatusInGroup?.camp?.reservation} students={studentStatusInGroup.camp.reservationStudents}/>
                        <CardNumbers title={"Gratis"} type={"warning"} number={studentStatusInGroup?.camp?.free} />
                    </Card>
                    {/* <div class="item-9 grid-item grid-item--width-6 grid-item--height-3">
                        <div class="dashboard__card">
                            <div class="dashboard__card-header">
                                <div class="dashboard__card-title">Procenat popunjenosti grupa</div>
                                <div class="dashboard__card-actions">
                                    <button class="btn-dash-more">
                                        <i class="fa-regular fa-ellipsis-vertical"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="dashboard__card-body">
                                <div class="dashboard__card-chart-9"></div>
                            </div>
                        </div>
                    </div>
                    <div class="item-7 grid-item grid-item--width-3 grid-item--height-3">
                        <div class="dashboard__card">
                            <div class="dashboard__card-header">
                                <div class="dashboard__card-title">Nepopunjene liste napretka</div>
                                <div class="dashboard__card-actions">
                                    <button class="btn-dash-more">
                                        <i class="fa-regular fa-ellipsis-vertical"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="dashboard__card-body">
                                <div class="dashboard__card-chart-7"></div>
                                <div class="dashboard__card-mini-title">
                                    Lista polaznika za koje nije
                                    <br />
                                    evidentiran napredak.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item-8 grid-item grid-item--width-3 grid-item--height-3">
                        <div class="dashboard__card">
                            <div class="dashboard__card-header">
                                <div class="dashboard__card-title">Nepopunjeni planovi</div>
                                <div class="dashboard__card-actions">
                                    <button class="btn-dash-more">
                                        <i class="fa-regular fa-ellipsis-vertical"></i>
                                    </button>
                                </div>
                                <div class="dashboard__card-info dashboard__card-info--error">
                                    <span class="num purecounter" data-purecounter-start="0" data-purecounter-end="3" data-purecounter-duration="1"></span>
                                    <span class="txt">grupe</span>
                                </div>
                            </div>
                            <div class="dashboard__card-slider">
                                <div class="swiper">
                                    <div class="swiper-wrapper">
                                        <div class="swiper-slide">
                                            <div class="dashboard__card-slider-item-img">
                                                <img src="assets/img/dash-ico-1.svg" alt="" />
                                            </div>
                                        </div>
                                        <div class="swiper-slide">
                                            <div class="dashboard__card-slider-item-img" style={{background: "#17bfba"}}>
                                                <img src="assets/img/dash-ico-2.svg" alt="" />
                                            </div>
                                        </div>
                                        <div class="swiper-slide">
                                            <div class="dashboard__card-slider-item-img" style={{background: "#aed25f"}}>
                                                <img src="assets/img/dash-ico-4.svg" alt="" />
                                            </div>
                                        </div>
                                        <div class="swiper-slide">
                                            <div class="dashboard__card-slider-item-img">
                                                <img src="assets/img/dash-ico-3.svg" alt="" />
                                            </div>
                                        </div>
                                        <div class="swiper-slide">
                                            <div class="dashboard__card-slider-item-img" style={{background: "#f89954"}}>
                                                <img src="assets/img/dash-ico-1.svg" alt="" />
                                            </div>
                                        </div>
                                        <div class="swiper-slide">
                                            <div class="dashboard__card-slider-item-img" style={{background: "#17bfba"}}>
                                                <img src="assets/img/dash-ico-2.svg" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="dashboard__card-slider-pagination swiper-pagination"></div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <Card
                        item={10} width={12} height={3}
                        actions={[
                            { label: "Izvesti", icon: "fa-regular fa-cloud-arrow-down", onClick: () => console.log("edit") },
                        ]}
                    >
                        <List>
                            <ListHeader>
                            <ListTitle title={"Vezani izostanci"} subtitle="Equilibrio Kids and Teens" />
                            </ListHeader>
                            <ListBody>
                                <TableHead>
                                    <TableRow>
                                        <TableHeadCell>Ime i prezime</TableHeadCell>
                                        <TableHeadCell>Staratelj</TableHeadCell>
                                        <TableHeadCell>Broj telefona</TableHeadCell>
                                        <TableHeadCell>Grupa</TableHeadCell>
                                        <TableHeadCell></TableHeadCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {students.map((student, index) => (
                                        <TableRow key={index}>
                                            <TableDataCell>{student.fullName}</TableDataCell>
                                            <TableDataCell>{student.guardian1FirstName + ' ' + student.guardian1LastName}</TableDataCell>
                                            <TableDataCell>{student.phoneNumber}</TableDataCell>
                                            <TableDataCell>
                                                <Button 
                                                    title={student.groupName}
                                                    onClick={() => gotoEditGroup(student.groupId)}
                                                />
                                            </TableDataCell>
                                            <TableDataCell>
                                            </TableDataCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </ListBody>
                        </List>
                    </Card>
                </DashboardWrapper>
            </Main>
        </DefaultLayout>
    );
};

export default Dashboard;
